import { render } from "./EditableTable.vue?vue&type=template&id=2e878074&scoped=true"
import script from "./EditableTable.vue?vue&type=script&lang=js"
export * from "./EditableTable.vue?vue&type=script&lang=js"

import "./EditableTable.vue?vue&type=style&index=0&id=2e878074&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e878074"]])

export default __exports__